import React from 'react';

import { Muster } from '@/app/_components/Muster';
import { MusterProps } from './types';

import classes from './index.module.scss';

export const MusterGraphQL: React.FC<MusterProps> = props => {
  const { id } = props;

  return (
    <div id={`block-${id}`} className={classes.blockWrapper}>
      <Muster muster={props} />
    </div>
  );
};

export default MusterGraphQL;
